import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'bp-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    
})
export class ErrorComponent {

  constructor() { }
}
